import React from 'react'
import ReactDOM from 'react-dom'
// import registerServiceWorker from './registerServiceWorker';//提高代码实行速度
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index'
import history from './common/utils/history'
// import { setEnabled } from 'react-error-overlay'

ReactDOM.render(
  <BrowserRouter history={history}>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
)
// registerServiceWorker();
// setEnabled(process.env.NODE_ENV === 'development')
// setEnabled(false)
